import { useTranslation } from 'react-i18next';

const LOGO_URL = 'https://assets.urbansitter.com/static/img/logos/urbansitter_logo_color.svg';

export const NuxHeader = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <header className='py-3.5 border-b-4 border-neutral-100'>
      <div className='container'>
        <img src={LOGO_URL} alt={t('components.header.logo.alt')} className='w-auto' />
      </div>
    </header>
  );
};
